import templateSlice from './templateSlice'
export default templateSlice.reducer
